<div [ngClass]="{ 'flex flex-col w-full h-dvh': true }">
  <!-- <header [ngClass]="{ 'pt-6 pl-6 bg-transparent fixed top-0 left-0': true }">
    <div class="flex items-center">
      <img
        [ngSrc]="'assets/login-assets/pay_kaduna_icon.png'"
        alt="primeguage-logo"
        priority
        width="62"
        height="52.5"
        [ngClass]="{ 'h-[52.5px] w-[62px]': true }"
      />
      <p
        [ngClass]="{
          'text-[#292929] text-[20px] leading-[150%] -tracking-[1px] font-extrabold': true,
        }"
      >
        PAYKADUNA
      </p>
    </div>
  </header> -->
  <div [ngClass]="{ 'h-svh w-full flex flex-1': true }">
    <div
      [ngClass]="{
        'flex-1 flex justify-center items-center px-11 background-gradient': true,
      }"
      style="
        background-image: url(&quot;/assets/login-assets/support-login-bg.jpg&quot;);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top right;
      "
    >
      <!-- <div
        [ngClass]="{
          'flex items-center justify-center py-6 bg-white w-full': true,
        }"
      >
         <img
          [ngSrc]="'assets/login-assets/support-login-bg.png'"
          alt="primeguage-logo"
          priority
          width="636"
          height="636"
          [ngClass]="{ 'h-[636px] w-[636px]': true }"
        /> 
      </div> -->
    </div>

    <div
      [ngClass]="{
        'overflow-hidden flex-1 bg-[#F8F8F8] px-9 py-10 flex flex-col items-center relative': true,
      }"
    >
      <div class="w-full absolute top-10 left-20">
        <app-back-button-route></app-back-button-route>
      </div>

      <div class="min-h-full flex flex-col items-center justify-center w-full">
        <div
          class="flex items-center mt-10 cursor-pointer"
          (click)="router.navigate(['/'])"
        >
          <img
            [ngSrc]="'assets/login-assets/pay_kaduna_icon.png'"
            alt="primeguage-logo"
            priority
            width="62"
            height="52.5"
            [ngClass]="{ 'h-[52.5px] w-[62px]': true }"
          />
          <p
            [ngClass]="{
              'text-[#292929] text-[20px] leading-[150%] -tracking-[1px] font-extrabold': true,
            }"
          >
            PAYKADUNA
          </p>
        </div>

        <div
          class="w-full p-8 bg-white rounded-2xl max-w-[554px] mx-auto mt-10 space-y-6"
        >
          <div
            [ngClass]="{
              'flex flex-col items-center justify-center gap-6': true,
            }"
          >
            <h3
              [ngClass]="{
                'text-[#292929] font-bold text-lg text-center': true,
              }"
            >
              Support Login
            </h3>
          </div>

          <div>
            <form
              [formGroup]="authForm"
              (ngSubmit)="onSubmit()"
              class="flex flex-col flex-1 w-full p-4"
            >
              <div class="flex flex-col gap-6 pb-4">
                <div class="w-full mx-auto">
                  <label for="" class="flex flex-col">
                    <div class="relative flex w-full">
                      <!-- <input appGeneralInput type='email' placeholder="Enter email" formControlName="email" /> -->
                      <app-general-input
                        label="Email"
                        type="email"
                        placeholder="Enter email"
                        controlName="email"
                        [formGroup]="authForm"
                      ></app-general-input>

                      <div
                        *ngIf="
                          !!authForm.get('email')?.errors &&
                          authForm.get('email')?.touched
                        "
                        class="absolute top-[calc(100%+1px)] text-[12px] pl-[5px] text-[#EB5757] flex items-center gap-[4px]"
                      >
                        <span *ngIf="authForm.get('email')?.errors?.email">{{
                          "Invalid email"
                        }}</span>
                        <span *ngIf="authForm.get('email')?.errors?.required"
                          >Field is required</span
                        >
                      </div>
                    </div>
                  </label>
                </div>
                <div class="w-full mx-auto">
                  <label for="" class="flex flex-col">
                    <div class="relative flex w-full">
                      <app-password-input
                        label="Password"
                        placeholder="Enter password"
                        controlName="password"
                        [formGroup]="authForm"
                      ></app-password-input>

                      <div
                        class="absolute top-[calc(100%+1px)] text-[12px] pl-[5px] text-[#EB5757] flex items-center gap-[4px]"
                        *ngIf="
                          !!authForm.get('password')?.errors &&
                          authForm.get('password')?.touched
                        "
                      >
                        <span *ngIf="authForm.get('password')?.errors?.required"
                          >Field is required</span
                        >
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <div [ngClass]="{ 'flex justify-between pt-4': true }">
                <label nz-checkbox formControlName="rememberMe">
                  Remember me
                </label>

                <button
                  type="button"
                  class="text-sm leading-6 underline text-[#178CA6] underline-offset-[3px] text-center font-bold"
                  [routerLink]="['/forgot-password']"
                  [queryParams]="{ returnUrl: '/support-login' }"
                >
                  Forgot password
                </button>
              </div>

              <div class="mt-auto text-center pt-6">
                <button
                  appGeneralButton
                  type="submit"
                  [disabled]="mutation.isPending()"
                  [ngClass]="{
                    'disabled:opacity-50 !bg-[#178CA6] capitalize': true,
                  }"
                >
                  {{
                    mutation.isPending()
                      ? "Logging in.\
                    Please\
                    wait..."
                      : "Login"
                  }}
                </button>
              </div>
            </form>
          </div>

          <p class="text-center">
            PayKaduna.... setting the pace in Tax Administration
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
